import React, { useEffect, useState } from "react";
import DatePicker from "../DatePicker";
import { getCashflowReport } from "../../utils/dataFetch";

export default function ReportModal({ toggleModal, selectedCashAcc }) {
    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    const firstDayOfCurrentTheYear = new Date(new Date().getFullYear(), 0, 2);

    const [startDate, setStartDate] = useState(
        lastMonth.toISOString().split("T")[0]
    );
    const [endDate, setEndDate] = useState(today.toISOString().split("T")[0]);

    // Dashboard scroll lock when modal window is open
    useEffect(() => {
        document.body.classList.add("modal--open");
        return () => {
            document.body.classList.remove("modal--open");
        };
    }, []);

    function getReportData(data) {
        let arrivalSum = 0;
        let paymentSum = 0;

        let resultObject = data.reduce((acc, item) => {
            if (!acc[item.article_id]) {
                acc[item.article_id] = {
                    article_id: item.article_id,
                    name: item.article_label,
                    arrival: 0,
                    payment: 0,
                };
            }

            acc[item.article_id].arrival += item.arrival;
            acc[item.article_id].payment += item.payment;

            arrivalSum += item.arrival;
            paymentSum += item.payment;

            return acc;
        }, {});

        let resultArray = Object.values(resultObject);

        return {
            reportData: resultArray,
            overall: {
                arrivalSum: arrivalSum.toFixed(2),
                paymentSum: paymentSum.toFixed(2),
            },
        };
    }

    const [dataError, setDataError] = useState("");
    const [cashflowReport, setCashflowReport] = useState([]);
    const [overallCashflowReport, setOverallCashflowReport] = useState([]);

    useEffect(() => {
        const fetchCashflowReport = async () => {
            try {
                const cashflowReportResult = await getCashflowReport(
                    startDate + "T0:0:0.0Z",
                    endDate + "T23:59:59.999Z",
                    selectedCashAcc.id
                );

                const report = getReportData(cashflowReportResult);

                setCashflowReport(report.reportData);
                setOverallCashflowReport(report.overall);
            } catch (error) {
                setDataError("Помилка завантаження даних!");
            }
        };
        fetchCashflowReport();
    }, [startDate, endDate, selectedCashAcc.id]);

    return (
        <div className="report--debt modal--backdrop">
            <div className="modal d-block" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content rounded-5">
                        <div className="modal-header">
                            <h5 className="modal-title ms-2">
                                Звіт про рух коштів{" "}
                                <span className="fw-bold">
                                    {selectedCashAcc.name}
                                </span>
                            </h5>
                            <button
                                type="button"
                                className="btn-close me-0"
                                onClick={toggleModal}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3 me-2 me-sm-0">
                                <DatePicker
                                    startDate={startDate}
                                    endDate={endDate}
                                    onStartDateChange={setStartDate}
                                    onEndDateChange={setEndDate}
                                    minStartDate={firstDayOfCurrentTheYear}
                                    maxPeriodInDays={365}
                                />
                            </div>
                            {/* Table */}
                            {dataError && (
                                <div className="alert alert-danger rounded-5 m-auto">
                                    {dataError}
                                </div>
                            )}
                            {!dataError && (
                                <>
                                    <div className="table-responsive border border-secondary rounded-4">
                                        <table className="table table-sm table-striped-columns table-light m-0">
                                            <thead>
                                                <tr>
                                                    <th
                                                        className="text-center align-middle table-active"
                                                        scope="col"
                                                    >
                                                        Стаття
                                                    </th>
                                                    <th
                                                        className="text-center align-middle table-active"
                                                        scope="col"
                                                    >
                                                        Прихід
                                                    </th>
                                                    <th
                                                        className="text-center align-middle table-active"
                                                        scope="col"
                                                    >
                                                        Оплата
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {cashflowReport.map(
                                                    (item, index) => (
                                                        <tr key={index}>
                                                            <td className="text-start align-start">
                                                                {item.name}
                                                            </td>
                                                            <td
                                                                className={`text-center align-middle ${
                                                                    item.arrival <
                                                                        0 &&
                                                                    "text-danger"
                                                                }`}
                                                            >
                                                                {Number(
                                                                    item.arrival
                                                                ) === 0
                                                                    ? ""
                                                                    : item.arrival.toFixed(
                                                                          2
                                                                      )}
                                                            </td>
                                                            <td
                                                                className={`text-center align-middle ${
                                                                    item.payment <
                                                                        0 &&
                                                                    "text-danger"
                                                                }`}
                                                            >
                                                                {Number(
                                                                    item.payment
                                                                ) === 0
                                                                    ? ""
                                                                    : item.payment.toFixed(
                                                                          2
                                                                      )}
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        className="text-start align-start table-active"
                                                    >
                                                        Разом
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        className="text-center align-middle table-active"
                                                    >
                                                        {
                                                            overallCashflowReport.arrivalSum
                                                        }
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        className="text-center align-middle table-active"
                                                    >
                                                        {
                                                            overallCashflowReport.paymentSum
                                                        }
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row d-flex justify-content-center mt-3 mb-2 mb-sm-0">
                                        <button
                                            className="btn btn-sm main--button w-auto"
                                            onClick={toggleModal}
                                        >
                                            Закрити
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
